<template>
  <input
    v-bind="$attrs"
    :type="type"
    class="base-input"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
  />
</template>

<script>
export default {
  name: 'BaseInput',
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    }
  }
};
</script>

<style scoped>
.base-input {
  width: 100%;
  padding: 0.6rem 1rem;
  border: 1px solid var(--border-color, #ccc);
  border-radius: 0.5rem;
  font-size: 1rem;
  transition: border-color 0.2s;
}
.base-input:focus {
  outline: none;
  border-color: var(--color-primary, #007bff);
}
</style>
